import {SpacierArcadeReelSymbol} from "./SpacierArcadeReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";

export class SpacierArcadeWildSymbol extends SpacierArcadeReelSymbol{
    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations():void {
        let _this = this;
        let spinName:string = this.useMainSymbols()? SpacierArcadeGameAssets.WILD_SYMBOL :SpacierArcadeGameAssets.WILD_SYMBOL_FS;
        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset(spinName));
        this._spine.autoUpdate = true;
        this._spine.state.setAnimation(0, "idle", true);
        this._spine.state.setAnimation(1, "wild_w", true);
        this._spine.name = "wild";
        this.addChild(this._spine);
    }

    protected useMainSymbols():boolean {
        if(SpacierArcadeGameConfig.instance.reelViewExpanded !== undefined){
            return !SpacierArcadeGameConfig.instance.reelViewExpanded;
        }
        return !SpacierArcadeModeData.instance.isFreespin;
    }

    private hasOverlayAbove():boolean{
        let hasOverlay:boolean = false;
        let index = this.controller.allSymbols.indexOf(this);
        return SpacierArcadeModeData.instance.isRespin && SpacierArcadeModeData.instance.overlaySymbolsBeforeSpin[this.reelId][index - 1] !== null;
    }

    protected getStateTl(state:string, stateAnimation:TimelineSprite):TimelineLite {
        const stateTl:TimelineLite = new TimelineLite();

        switch (state) {
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.normal.keyword:
                if(this._spine.state !== null) {
                    if(this.multiplier){
                        stateTl.add(() => {
                            if(this.multiplier > 1){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        });
                    }
                    stateTl.add([
                        new SpineTween(this._spine, 2, null)]);

                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.attention.keyword:
                if(this._controller !== undefined && !this.hasOverlayAbove()) {
                    if(this._spine.state !== null) {
                        stateTl.add([
                            () => {
                                if(this.multiplier > 1){
                                    new SpineTween(this._spine, 1, "x_idle", -1);
                                    this._spine.skeleton.setSkinByName("x" + this.multiplier);
                                }
                            },
                            new SpineTween(this._spine, 2, "land")
                        ]);
                    }
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.landDead.keyword:
                if(this._controller !== undefined && !this.hasOverlayAbove()) {
                    if(this._spine.state !== null) {
                        stateTl.add([
                            () => {
                                if(this.multiplier > 1){
                                    new SpineTween(this._spine, 1, "x_idle", -1);
                                    this._spine.skeleton.setSkinByName("x" + this.multiplier);
                                }
                            },
                            new SpineTween(this._spine, 2, "land_dead")
                        ]);
                    }
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.spin.keyword:
                if(this._controller !== undefined) {
                    this._controller.moveSymbolToBottomLayer(this);
                }

                if(this._spine.state !== null) {
                    this._spine.state.setAnimation(2, "spin", true);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.fsStickyWild.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([
                        new SpineTween(this._spine, 2, "land_fs")
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.sticky.keyword:
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyPump.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([
                        () => {
                            if(this.multiplier > 1){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        },
                        new SpineTween(this._spine, 2, "sticky", -1)
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.win.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([new SpineTween(this._spine, 2, "win"),
                        () => {
                            if(this.multiplier > 1){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        }]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.winMulti.keyword:
                if(this._controller !== undefined && !this.hasOverlayAbove()) {
                    this._controller.moveSymbolToSpecialLayer(this);
                }
                if(this._spine.state !== null) {
                    stateTl.add([
                        () => new SpineTween(this._spine, 3, "tiny_win"),
                        () => {
                            if(this.multiplier > 0){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        }
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.multiplier.keyword:
                if(this._controller !== undefined && !this.hasOverlayAbove()) {
                    this._controller.moveSymbolToSpecialLayer(this);
                }
                if(this._spine.state !== null) {
                    stateTl.add([
                        () => new SpineTween(this._spine, 3, "win_toggle"),
                        () => {
                            if(this.multiplier > 0){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        }
                    ]);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.noWin.keyword:
                if(this._controller !== undefined) {
                    this._controller.moveSymbolToBottomLayer(this);
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.individualWin.keyword:
                if(this._spine.state !== null) {
                    stateTl.add(new SpineTween(this._spine, 2, "win_toggle"));
                }
                break;
            case SpacierArcadeGameConfig.instance.SYMBOL_STATES.smallWin.keyword:
                if(this._spine.state !== null) {
                    stateTl.add([new SpineTween(this._spine, 2, "tiny_win"),
                        () => {
                            if(this.multiplier > 1){
                                new SpineTween(this._spine, 1, "x_idle", -1);
                                this._spine.skeleton.setSkinByName("x" + this.multiplier);
                            }
                        }]);
                }
                break;
        }

        return stateTl;
    }
}